import styled from 'styled-components';

export default styled.div`
  margin: 10px 0 20px;
`;
